<template>
  <svg
    width="18"
    height="9"
    viewBox="0 0 18 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
  >
    <path
      d="M16.5338 1L8.89192 8L1.25 1"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
